import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { TsrctRuleStatus } from '@/generated/gql/graphql';
import { RuleStatusChip } from '~/routes/RuleDetail/components/RuleStatusChip/RuleStatusChip.tsx';

export type RuleStatusChipCellValue = Union.Nullable<keyof typeof TsrctRuleStatus>;

interface RuleStatusChipCellProps<R extends GridValidRowModel = any> {
  value: RuleStatusChipCellValue;
  row: R;
}

export const RuleStatusChipCell = <R extends GridValidRowModel = any>({ value }: RuleStatusChipCellProps<R>) => {
  // div wrapper needed to display chip correctly
  return value ? (
    <div>
      <RuleStatusChip status={value} />
    </div>
  ) : (
    <>{NULLISH_CELL_VALUE}</>
  );
};
